import { IRecordType } from 'types/recordType';
import { getRecordTypeSlug } from 'utils/recordTypeSlug';

/**
 * Utility function to open a record in a new tab.
 * @param recordId {String}
 * @param recordTypeId {String}
 */
export const openInANewTabRecordViewAction = (recordId: string, recordType: IRecordType) => {
    const tenantUrl = localStorage.getItem('tenantPath');
    if (!tenantUrl || !recordId || !recordType) return;
    window.open(
        `${tenantUrl}/accounting/doc-viewer/${getRecordTypeSlug(recordType.name)}?recordId=${recordId}&recordType=${recordType.id}`,
        '_blank'
    );
};

/**
 * Utility function to open a record in the current tab.
 * @param recordId {String}
 * @param recordTypeId {String}
 */
export const openInThisTabRecordViewAction = (recordId: string, recordType: IRecordType) => {
    const tenantUrl = localStorage.getItem('tenantPath');
    if (!tenantUrl || !recordId || !recordType) return;
    window.location.href = `${tenantUrl}/accounting/doc-viewer/${getRecordTypeSlug(recordType.name)}?recordId=${recordId}&recordType=${
        recordType.id
    }`;
};
